const rubricTranslations = {
  ru: {
    'Demographics (age, ethnicity, gender)': 'Демография (возраст, этническая принадлежность, пол)',
    'Chief complaint and symptom chronology': 'Основная жалоба и хронология симптомов',
    'Medication history (SGLT2 inhibitor use)': 'Лекарственный анамнез (использование ингибитора SGLT2)',
    'Social determinants (homelessness, food insecurity)': 'Социальные факторы (бездомность, нехватка еды)',
    'Family history of diabetes and cardiac disease': 'Семейный анамнез диабета и сердечно-сосудистых заболеваний',
    'Physical examination findings': 'Данные физикального осмотра',
    'Laboratory investigations': 'Лабораторные исследования',
    'Investigations': 'Исследования',
    'Diagnosis': 'Диагноз',
    'Management plan': 'План лечения',
    'Differential diagnosis': 'Дифференциальный диагноз',
    'Safety netting': 'Рекомендации по безопасности',
    'Follow-up': 'Дальнейшее наблюдение',
    'no history provided': 'анамнез не собран',
    'no history assessment provided': 'анамнез не оценён',
    'no diagnosis provided': 'диагноз не указан',
    'no management plan provided': 'план лечения не указан',
    'Provide a complete history including presenting symptoms, past medical history, family history, social history, medication list, and physical examination findings.': 'Соберите полный анамнез: текущие симптомы, анамнез заболеваний, семейный и социальный анамнез, список лекарств и данные физикального осмотра.',
    'Provide a detailed history including presenting symptoms, duration, associated features, past medical history, family history, social history, and review of systems': 'Соберите подробный анамнез: текущие симптомы, длительность, сопутствующие признаки, анамнез заболеваний, семейный и социальный анамнез и обзор систем.',
    'Persistent hyperglycemia': 'Стойкая гипергликемия',
    'Hypertension with postural component': 'Гипертензия с ортостатическим компонентом',
    'Episodes of confusion': 'Эпизоды спутанности сознания',
    'Medication adherence issues': 'Проблемы с соблюдением режима приёма лекарств',
    'Insulin storage challenges': 'Трудности с хранением инсулина',
    'Inconsistent diet': 'Нерегулярное питание',
    'Elevated HbA1c': 'Повышенный HbA1c',
    'Elevated creatinine': 'Повышенный креатинин',
    'Liver cirrhosis status': 'Наличие цирроза печени',
    'CKD stage 3b': 'ХБП стадии 3b',
    'Dyslipidemia': 'Дислипидемия',
    'Potential hepatic encephalopathy': 'Возможная печёночная энцефалопатия',
    'List all relevant diagnoses and differential diagnoses with clinical reasoning.': 'Перечислите все вероятные диагнозы и дифференциальные диагнозы с клиническим обоснованием.',
    'Develop a comprehensive management plan covering pharmacologic, non-pharmacologic, monitoring, and follow-up.': 'Составьте полный план лечения: медикаментозные и немедикаментозные меры, мониторинг и дальнейшее наблюдение.',
    'Review the section details for strengths and areas to improve.': 'Изучите детали разделов: что получилось хорошо и что нужно улучшить.'
  },
  uz: {
    'Demographics (age, ethnicity, gender)': 'Demografik ma’lumotlar (yosh, etnik kelib chiqish, jins)',
    'Chief complaint and symptom chronology': 'Asosiy shikoyat va simptomlar ketma-ketligi',
    'Medication history (SGLT2 inhibitor use)': 'Dori anamnezi (SGLT2 ingibitori qabul qilishi)',
    'Social determinants (homelessness, food insecurity)': 'Ijtimoiy omillar (boshpanasizlik, oziq-ovqat yetishmovchiligi)',
    'Family history of diabetes and cardiac disease': 'Oilaviy anamnez: diabet va yurak-qon tomir kasalliklari',
    'Physical examination findings': 'Fizikal ko‘rik natijalari',
    'Laboratory investigations': 'Laborator tekshiruvlar',
    'Investigations': 'Tekshiruvlar',
    'Diagnosis': 'Tashxis',
    'Management plan': 'Davolash rejasi',
    'Differential diagnosis': 'Differensial tashxis',
    'Safety netting': 'Xavfsizlik bo‘yicha tavsiyalar',
    'Follow-up': 'Keyingi kuzatuv',
    'no history provided': 'anamnez yig‘ilmagan',
    'no history assessment provided': 'anamnez baholanmagan',
    'no diagnosis provided': 'tashxis kiritilmagan',
    'no management plan provided': 'davolash rejasi kiritilmagan',
    'Provide a complete history including presenting symptoms, past medical history, family history, social history, medication list, and physical examination findings.': 'To‘liq anamnez yig‘ing: hozirgi simptomlar, o‘tkazilgan kasalliklar, oilaviy va ijtimoiy anamnez, dori ro‘yxati hamda fizik ko‘rik topilmalari.',
    'Provide a detailed history including presenting symptoms, duration, associated features, past medical history, family history, social history, and review of systems': 'Batafsil anamnez yig‘ing: hozirgi simptomlar, davomiyligi, hamroh belgilar, o‘tkazilgan kasalliklar, oilaviy va ijtimoiy anamnez hamda tizimlar bo‘yicha so‘rov.',
    'Persistent hyperglycemia': 'Doimiy giperglikemiya',
    'Hypertension with postural component': 'Holat o‘zgarganda kuchayadigan gipertenziya',
    'Episodes of confusion': 'Ong chalkashishi epizodlari',
    'Medication adherence issues': 'Dori-darmonlarni muntazam qabul qilishdagi muammolar',
    'Insulin storage challenges': 'Insulinni saqlashdagi qiyinchiliklar',
    'Inconsistent diet': 'Noto‘g‘ri va nomuntazam ovqatlanish',
    'Elevated HbA1c': 'HbA1c ko‘tarilgan',
    'Elevated creatinine': 'Kreatinin ko‘tarilgan',
    'Liver cirrhosis status': 'Jigar sirrozi holati',
    'CKD stage 3b': 'Surunkali buyrak kasalligi 3b-bosqich',
    'Dyslipidemia': 'Dislipidemiya',
    'Potential hepatic encephalopathy': 'Ehtimoliy jigar ensefalopatiyasi',
    'List all relevant diagnoses and differential diagnoses with clinical reasoning.': 'Barcha mos tashxislar va differensial tashxislarni klinik asos bilan yozing.',
    'Develop a comprehensive management plan covering pharmacologic, non-pharmacologic, monitoring, and follow-up.': 'Dori-darmon, dorisiz choralar, monitoring va keyingi kuzatuvni qamrab olgan to‘liq davolash rejasini tuzing.',
    'Review the section details for strengths and areas to improve.': 'Kuchli jihatlar va yaxshilash kerak bo‘lgan joylar uchun bo‘lim tafsilotlarini ko‘rib chiqing.'
  }
};

const translateSentence = (text, language) => {
  const dictionary = rubricTranslations[language];
  if (!dictionary || !text) return text;

  const lowerKey = Object.keys(dictionary).find((english) => english.toLowerCase() === text.toLowerCase());
  let translated = dictionary[text] || (lowerKey ? dictionary[lowerKey] : text);
  Object.entries(dictionary).forEach(([english, localized]) => {
    translated = translated.replaceAll(english, localized);
    translated = translated.replace(new RegExp(escapeRegExp(english), 'gi'), localized);
  });
  return translated;
};

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const translateEvaluationText = (value, language) => {
  const text = typeof value === 'string' ? value : String(value ?? '');
  if (!text || language === 'en') return text;

  const pointsMatch = text.match(/^(-?\d+)\s*points?:\s*(.+)$/i);
  if (pointsMatch) {
    const [, points, reason] = pointsMatch;
    const unit = language === 'ru' ? 'балл' : 'ball';
    return `${points} ${unit}: ${translateSentence(reason, language)}`;
  }

  return translateSentence(text, language);
};
